import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Определяем язык на основе URL
  useEffect(() => {
    const pathLang = location.pathname.startsWith('/ru') ? 'ru' : 'de';
    if (i18n.language !== pathLang) {
      i18n.changeLanguage(pathLang);
    }
  }, [location.pathname, i18n]);
  
  const changeLanguage = (language) => {
    console.log('useTranslation - changing language to:', language);
    
    // Меняем язык в i18n
    i18n.changeLanguage(language);
    
    // Меняем URL
    let newPath = location.pathname;
    
    if (language === 'ru') {
      // Добавляем /ru к пути
      if (newPath.startsWith('/ru')) {
        // Уже русский путь, ничего не делаем
        return;
      } else {
        // Немецкий путь -> русский путь
        newPath = newPath === '/' ? '/ru' : `/ru${newPath}`;
      }
    } else {
      // Убираем /ru из пути (переключаемся на немецкий)
      if (newPath.startsWith('/ru')) {
        newPath = newPath.replace(/^\/ru/, '') || '/';
      }
    }
    
    navigate(newPath);
  };
  
  const currentLanguage = i18n.language;
  
  // Отладочная информация
  console.log('useTranslation - currentLanguage:', currentLanguage, 'isRussian:', currentLanguage === 'ru');
  
  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage,
    isGerman: currentLanguage === 'de',
    isRussian: currentLanguage === 'ru'
  };
};

export default useTranslation;
